import "./SupportCenter.module.css";
import Header from "@/reusable_sections/Header";
import TechnicalFaq from "./sections/TechnicalFaq";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function SupportCenterPage() {
  return <div>
      <Header />
      <TechnicalFaq />
      <Inquiry />
      <Footer />
    </div>;
}